import { Anlage } from "./anlage"

export class UrlAnlage extends Anlage {
    url = ""

    get notEmpty(): boolean {
        return this.url.trim().length > 0
    }

    toJSON() {
        return {
            "@type": "urlAnlage",
            name: this.name,
            beschreibung: this.beschreibung,
            url: this.url,
        }
    }
}
